import { keyframes, css } from "styled-components"

const goahead = keyframes`
  0% { 
    width:6px;
    background-color:#f7f7f7;
  }
60%{
  width:100%;
  background-color:#f7f7f7;
}
  100% { 
    width:100%;
    background-color:gold;
  }
`
export const animationGoAhead = css`
  animation-name: ${goahead};
  animation-duration: 0.5s;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-direction: normal;
  animation-fill-mode: both;
  animation-play-state: running;
`

const rotationR = keyframes`
0% {
  transform: rotate(360deg);
}
100% {
  transform: rotate(0deg);
}
`
const rotationL = keyframes`
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg); 
}
`

export const animationRotate360L = css`
  animation-name: ${rotationL};
  animation-duration: 0.3s;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  /* animation-direction: normal; */
  /* animation-fill-mode: both; */
  /* animation-play-state: running; */
`
export const animationRotate360R = css`
  animation-name: ${rotationR};
  animation-duration: 0.3s;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  /* animation-direction: normal; */
  /* animation-fill-mode: both; */
  /* animation-play-state: running; */
`
